import { type ExtraFeature } from '@/app/routing/guards/extraFeatures';
import { type MinimalUser } from '@/generated/model';
import { type PopupType } from '@/types';

export type PopupPlatform = 'mobile' | 'desktop';

export type PopupVisibilityOptions = {
  user?: MinimalUser;
  chatId?: string;
  platform: PopupPlatform;
  isTokenUser: boolean;
  hasExtraFeature: (extraFeature: ExtraFeature) => boolean;
};

export function filterVisiblePopups(popups: PopupType[], options: PopupVisibilityOptions): PopupType[] {
  return popups.flatMap((popup) => {
    if (popup.hidden) {
      return [];
    }
    if (options.platform === 'mobile' && !popup.showMobile) {
      return [];
    }
    if (popup.requiredExtraFeature && !options.hasExtraFeature(popup.requiredExtraFeature)) {
      return [];
    }
    if (options.isTokenUser && !popup.showToken) {
      return [];
    }
    if (popup.show && !popup.show(options.user, options.chatId)) {
      return [];
    }

    if (!popup.children) {
      return [{ ...popup }];
    }

    const children = filterVisiblePopups(popup.children, options);
    if (children.length === 0) {
      return [];
    }

    return [{ ...popup, children }];
  });
}
